module.exports = __webpack_public_path__ + "media/images/pixel_transparent153-1edcc9b5.png";